import './index.scss'
// import '../../assets/scripts/myNiceScroll'
// import {resizeScroll} from '../../assets/scripts/myNiceScroll'

$(document).ready(function(){
  $('.article img').each(function(index,value){
    if($(this).width() > 200){
      $(this).addClass('block')
    }
  })
})